import _ from 'lodash';
import Rx from 'ub_wrapped/rx';

import FontActions from 'ub/fonts/font-picker/button/font-actions';

const fontActionsSubject = new Rx.Subject();
const stateChangedSubject = new Rx.Subject();

let currentState = {};
let activeButtonElm;

const setActiveElement = (buttonElm) => {
  activeButtonElm = buttonElm;

  fontActionsSubject.onNext({type: 'updateButtonStyles'});
};

stateChangedSubject.subscribe((newState) => {
  currentState = newState;
});

fontActionsSubject
  .filter((ev) => { return !_.isEmpty(ev.type); })
  .subscribe((ev) => {
    const modalData = activeButtonElm && activeButtonElm.model;
    const newState = FontActions[ev.type](currentState, ev.value, modalData);

    stateChangedSubject.onNext(newState);
  });

export default {
  stateChangedSubject,
  fontActionsSubject,
  setActiveElement
};



// WEBPACK FOOTER //
// ./src/fonts/font-picker/button/state-controller.js